import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NotificationContent, NotificationStatus, NotificationInfo } from '@algoan/dashboard/model';

export interface AppState {
  notifications: NotificationInfo[];
  showOnboarding: boolean;
  errorMultiAccount: boolean;
}

const getInitialState = (): AppState => ({
  notifications: [],
  showOnboarding: false,
  errorMultiAccount: false,
});

const initialState = getInitialState();

const appStateSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    pushNotification(
      state: AppState,
      action: PayloadAction<{ timerId: number | NodeJS.Timeout; notification: NotificationContent }>,
    ) {
      state.notifications.push({ ...action.payload, notificationStatus: NotificationStatus.RENDERED });
    },
    popNotificationStart(state: AppState) {
      state.notifications[0].notificationStatus = NotificationStatus.FADING;
    },
    popNotificationFinish(state: AppState) {
      state.notifications.shift();
    },
    openOnboarding(state: AppState) {
      state.showOnboarding = true;
    },
    closeOnboarding(state: AppState) {
      state.showOnboarding = false;
    },
    errorMultiAccount(state: AppState) {
      state.errorMultiAccount = true;
    },
    closeErrorMultiAccount(state: AppState) {
      state.errorMultiAccount = false;
    },
  },
});

export const { reducer: appStateReducer } = appStateSlice;
export const {
  pushNotification,
  popNotificationStart,
  popNotificationFinish,
  openOnboarding,
  closeOnboarding,
  errorMultiAccount,
  closeErrorMultiAccount,
} = appStateSlice.actions;
